import dynamicAPI from '../dynamicAPI';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export default function useInbox({ page = 1, limit = 20, unreadOnly = false, refetchMs = 15000, enabled = true } = {}) {
    const qc = useQueryClient();

    const inbox = useQuery(
        ['inbox', page, limit, unreadOnly],
        async () =>
            await dynamicAPI(
                'get',
                `/api/auth/inbox?page=${page}&limit=${limit}${unreadOnly ? '&unread=1' : ''}`
            ),
        {
            enabled,
            retry: 0,
            staleTime: 30_000,
            cacheTime: 5 * 60_000,
            refetchOnWindowFocus: true,
            refetchInterval: refetchMs || false,
        }
    );

    const markRead = useMutation(
        async ({ kind, id }) => {
            if (kind === 'broadcast') {
                return dynamicAPI('post', `/api/auth/broadcast-inbox/${id}/read`);
            }
            return dynamicAPI('post', `/api/auth/notifications/${id}/read`);
        },
        { onSuccess: () => qc.invalidateQueries('inbox') }
    );

    const markAll = useMutation(
        async () => dynamicAPI('post', '/api/auth/inbox'),
        { onSuccess: () => qc.invalidateQueries('inbox') }
    );

    return { inbox, markRead, markAll };
}
